import { render, staticRenderFns } from "./PathwayDashboard.vue?vue&type=template&id=c0a4a84a&scoped=true"
import script from "./PathwayDashboard.vue?vue&type=script&lang=js"
export * from "./PathwayDashboard.vue?vue&type=script&lang=js"
import style0 from "./PathwayDashboard.vue?vue&type=style&index=0&id=c0a4a84a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a4a84a",
  null
  
)

export default component.exports